import React, {Component} from 'react';
import moment from 'moment';

class PopupThank extends Component {
    constructor(props) {
        super(props);
        this.handlePopupThank = this.handlePopupThank.bind(this);
    }

    handlePopupThank() {
        this.props.inactivePopupThank(false);
    }

    render() {
        let dateString = this.props.timePicker + ' ' + this.props.datePicker;
        let newDate = moment(dateString, "h:mm a YYYY-MM-DD");
        let date = moment(newDate).format('MMMM Do');
        let time = moment(newDate).format('h:mm a');
        return (
            <div id="popup-hair" className="slickModal isActive"
                 style={{"transition-duration": "0.4s"}}>
                <div className="slickOverlay closeModal setSlickCookie"
                     style={{'background': 'rgba(0, 0, 0, 0.85098)', 'transition-duration': '0.4s'}}></div>
                <div className="popup-thank slickWindow animated" style={{
                    'width': '88%',
                    'text-align': 'center',
                    'max-width': '620',
                    'box-shadow': 'rgba(0, 0, 0, 0.4) 0px 0px 20px 0px',
                    'background': 'rgb(255, 255, 255)',
                    'border-radius': '0px',
                    'margin': 'auto',
                    'animation-duration': '0.4s',
                    'animation-delay': '0.2'
                }}>
                    <div className="wrap wrap-popup-thank">
                        <div className="popup-icon"></div>
                        <h2>Thank you for booking with Stylu.</h2>
                        <div className="stylulist">
                            <strong>
                                <p>&nbsp;</p>
                                <p>Your appointment request is for {date} at {time}.</p>
                                <p>We will get back to you shortly with a confirmation once we confirm your stylist.</p>
                                <p>&nbsp;</p>
                                <p>If you have any questions regarding your appointment, email us at
                                    <a href="mailto:info@gostylu.com"> info@gostylu.com</a></p>
                                <p>&nbsp;</p>
                            </strong>
                        </div>
                    </div>
                    <button
                        type="submit"
                        className="button btn-primary"
                        style={{
                            'border-radius': '3px',
                            'width': '90%',
                            'font-size': '16px',
                            'line-height': '1',
                            'border': '0',
                            'background-color': '#00accd',
                            'height': '42px',
                            'color': '#fff',
                            'text-shadow': '0 1px rgba(0, 0, 0, 0.08)'
                        }}
                        onClick={this.handlePopupThank}
                    >
                        Book another appointment
                    </button>
                </div>
            </div>
        )
    }
}

export default PopupThank;



/** WEBPACK FOOTER **
 ** ./src/components/PopupThank.js
 **/